import React, { useRef} from 'react';
import { isInAPP } from 'hrg-fe-utils';
import { goBack, shareWB, setMLog } from '../../env/fun';
import './index.scss';
function Banner() {
    const alert = useRef();

    //返回按钮
    const back = () => {
        if (isInAPP) {
            goBack(true);
        } else {
            window.history.back(-1);
        }
    }
    return (
        <div className='banner-bg'>
            {isInAPP && <>
                <div className='banner-goback' onClick={() => back()}></div>
                <div className='banner-share'
                    onClick={() => {
                        shareWB("magicDay");
                        setMLog('2021magical_share');
                    }
                    }>
                </div>
            </>}
        </div>
    )
}
export default React.memo(Banner);